import {fetch} from '../utils/fetch'
import {casaApiUrl} from '../configs/casa-api'
import _ from 'lodash'

const matchConditions = [{type: 'at least', value: 0}, {type: 'at most', value: 1}, {type: 'exactly', value: 2}]

export const getBatchRuleCondition = (tenant, rules) => {
  return {
    batchRulesSource: `${tenant}/user`,
    className: 'Rule',
    isBatch: true,
    joinCondition: getJoinCondition(rules),
    triggers: []
  }
}

function getJoinCondition(rules) {
  return {
    className: 'JoinCondition',
    conditions: _.map(_.isEmpty(rules.conditions) ? rules : rules.conditions, ruleCondition => {
      if (ruleCondition.conditionType === 'list') {
        return getListCondition(ruleCondition)
      } else if (ruleCondition.conditionType === 'field') {
        return getFieldCondition(ruleCondition)
      } else if (ruleCondition.conditionType === 'join') {
        return getJoinCondition(ruleCondition)
      } else {
        return []
      }
    }),
    joinType: 1,
    negate: false
  }
}

function getListCondition(ruleCondition) {
  return {
    className: 'ListCondition',
    condition: getJoinCondition(ruleCondition),
    count: ruleCondition.value,
    countType: _.get(_.find(matchConditions, {type: ruleCondition.matchType}), 'value'),
    listAccessor: ruleCondition.listAccessor,
    negate: false
  }
}

function getFieldCondition(ruleCondition) {
  return {
    className: 'FieldCondition',
    fieldAccessor: ruleCondition.fieldAccessor,
    operator: {
      className: 'Operator',
      name: ruleCondition.operatorType,
      operatorType: 'number'
    },
    value: ruleCondition.value,
    negate: false
  }
}

function createRule(ruleInfo) {
  return fetch(`${casaApiUrl}/users/rule-configs`, {
    credentials: 'include',
    method: 'POST',
    body: JSON.stringify(ruleInfo),
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  })
    .then(res => {
      console.log(res)
      return res.json()
    })
}

export default {
  getBatchRuleCondition,
  createRule
}



// WEBPACK FOOTER //
// ./src/services/rules-service.js